// import React from 'react';
import Spinner from '../../components/Spinner';

// capitalize title
export const titleCase = (str) => {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
};

// convert string to LowerCase string
export const convertStrToLowerCase = (str) => {
    return str.toLowerCase();
};

// replace hyphen with space
export const replaceUnderscoreWithSpace = (str) => {
    return str.replace(/_/g, ' ');
};

// replace space with hyphen
export const replaceSpacewithUnderscore = (str) => {
    return str.replace(/ /g, '_');
};

// replace underscore with hyphen
export const replaceUnderscoreWithHyphen = (str) => {
    return str.replace(/_/g, '-');
};

// replace hyphen with space
export const replaceHyphenWithSpace = (str) => {
    return str.replace(/-/g, ' ');
};

// replace hyphen with underscore
export const replaceHyphenWithUnderscore = (str) => {
    return str.replace(/-/g, '_');
};

// replace space with hyphen
export const replaceSpacewithHyphen = (str) => {
    return str.replace(/ /g, '-');
};

// format display_url to plug into actual url
export const formatDisplayUrl = (url) => {
    {
        /*
        slice 'https://siberian.dev' from the url first
        split url on '/' and push it result result array
    */
    }
    const result = url.slice(21, url.length).split(/[/]/);
    if (result.length > 2) {
        return `${result[0]}/${result[2]}`;
    } else {
        return `${result[0]}/${result[1]}`;
    }
};

// convert string from seo-friendly str to original str
export const convertSeoFriendlyStrToOriginalStr = (str) => {
    {
        /*
        1. replace hyphen with space    eg: isolation-forest ==> isolation forest
        2. title case the str           eg: isolation forest ==> Isolation Forest
        3. replace spaces with hyphen   eg: Isolation Forest ==> Isolation-Forest
    */
    }
    return replaceSpacewithHyphen(titleCase(replaceHyphenWithSpace(str)));
};

// returns template name and subModel name for <breadcrumb and default tab selection>
export const findTemplateNameAndSubModelName = (data, modelName, subModelName) => {
    return new Promise((resolve, reject) => {
        var valid = false;
        var value;

        data.map((el1) => {
            let templateName = el1.name;
            el1.models.map((el2) => {
                if (
                    formatDisplayUrl(el2.display_url.toLowerCase()) ===
                    `${modelName.toLowerCase()}/${subModelName.toLowerCase()}`
                ) {
                    valid = true;
                    value = {
                        templateName: templateName,
                        subModelName2: el2.title,
                        seoTitle: el2.title,
                        seoMetaDescription: el2.description,
                        seoKeywords: el2.keywords,
                    };
                }
            });
        });

        if (valid) resolve(value);
        else reject();
    });
};

export const DisplaySpinner = () => {
    return (
        <div className="d-flex justify-content-center">
            <Spinner className="m-4" color={'primary'} />
        </div>
    );
};
